import { Badge, FlexBox, Text } from '@dixa/lib-shared-habla';

import { CustomForm } from '../../../customForms.types';
import { makeBadgeText } from '../utils/makeBadgeText';

type Props = {
  form: CustomForm;
};

export function FormTitle({ form }: Props): JSX.Element {
  return (
    <FlexBox flexDirection="column" justifyContent="space-between" gap="100">
      <Text.Heading variant="heading-2" clamp={100}>
        {form.title}
      </Text.Heading>

      {form.usage.length > 0 && (
        <Badge variant="secondary" size="small">
          {makeBadgeText(form)}
        </Badge>
      )}
    </FlexBox>
  );
}
